export { Tags, type TagsProps } from "./Tags";
